/**************************************************
 * Nombre:       Formulario_Comanda_Productos.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {Fastfood, FastfoodOutlined} from "@mui/icons-material";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import {useEffect, useState} from "react";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import Tarjeta_Productos_Escogidos from "../Tarjeta/Tarjeta_Productos_Escogidos";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Detalle_Producto_Comanda from "../Dialogos/Dialogo_Detalle_Producto_Comanda";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";

const Formulario_Comanda_Productos = ({...props}) => {
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Detalle_Producto_Comanda,
        titulo: 'Detalle Producto',
        realizado: props.realizado
    })
    const [productos, setProductos] = useState([]);
    const [cambia, setCambia] = useState(false);
    const {platosPedidos, setPlatosPedidos} = props
    const {getValues, setValue, watch,} = props.props

    const bucarProducto = () => {
        let id = getValues('codProducto')
        let cantidad = getValues('cantidadProducto')


        if (id) {
            let index = productos.findIndex(it => it.codigo === id.toUpperCase())
            if (index > -1) {
                let obj = {...productos[index], cantidad: cantidad ? cantidad : 1, estado: 'Produccion'}
                setPlatosPedidos((it) => it.concat(obj))
                setValue('codProducto', '')
                setValue('cantidadProducto', '')
            }
        }

        setCambia(!cambia);

    }


    useEffect(() => {

        obtenerCol('productos').then((dox) => {
            setProductos(dox.data);
        })

    }, [cambia])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Dialogo/>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{px: 1}}>
                    <Typography>Productos</Typography>
                </Grid>

                <Grid container size={3} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto nombre={'Cantidad'} {...props}
                                  dato={'cantidadProducto'}/>
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTextoBoton Icono={Fastfood} nombre={'Codigo Producto'} {...props}
                                       dato={'codProducto'} click={bucarProducto}/>
                </Grid>

                <Grid container size={3} sx={{justifyContent: 'flex-start'}}>
                    <Button fullWidth variant={'outlined'} endIcon={<FastfoodOutlined/>}>Menu</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    {platosPedidos.map((it, index) => (
                        <Tarjeta_Productos_Escogidos item={it} click={abrir} props={props}/>
                    ))}
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Comanda_Productos